// extracted by mini-css-extract-plugin
export default {"orgTitle":"DKRWIi_1HSlQhKNCme77","buttons":"OPeoCqvNpGHO1Ehh1zOA"};